import onKeyDownSearchInput from '../actions/onKeyDownSearchInput';
import getScenarioStore from '../store/getScenarioStore';
import KeyboardCharCodes from 'owa-hotkeys/lib/utils/keyboardCharCodes';
import { mutator } from 'satcheljs';

mutator(onKeyDownSearchInput, actionMessage => {
    const { evtKeyCode, scenarioId } = actionMessage;

    getScenarioStore(scenarioId).isLastKeyPressedDeletion =
        evtKeyCode === KeyboardCharCodes.Backspace || evtKeyCode === KeyboardCharCodes.Delete;
});
